import { FeatureType, type LibItemSysIcon } from '@types';

type Group = { name: string; featType?: FeatureType; list: LibItemSysIcon[] };

export const iconList: Group[] = [
  {
    name: '场景切换',
    featType: FeatureType.scene,
    list: [
      { url: '/hotspots/system/changjingqiehuan/qianjin1.png', frame: 1 },
      { url: '/hotspots/system/changjingqiehuan/zuozhuan1.png', frame: 1 },
      { url: '/hotspots/system/changjingqiehuan/youzhuan1.png', frame: 1 },
      { url: '/hotspots/system/changjingqiehuan/wurenji1.png', frame: 1 },
      { url: '/hotspots/system/changjingqiehuan/zhishengji1.png', frame: 1 },
      {
        url: '/hotspots/system/changjingqiehuan/shangyichangjin.png',
        frame: 1,
      },
      { url: '/hotspots/system/changjingqiehuan/xiayichangjin.png', frame: 1 },
      { url: '/hotspots/system/changjingqiehuan/zuozhuan2.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/youzhuan2.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/qianjin2.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/zuozhuan.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/youzhuan.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/jinmen.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/chumen.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/wurenji.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/zhishengji.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/yuandian.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/xfl-dianwei.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/3Dbiaoji.png', frame: 24 },
      {
        url: '/hotspots/system/changjingqiehuan/xfl-xiangqiang.png',
        frame: 24,
      },
      { url: '/hotspots/system/changjingqiehuan/xfl-xiangxia.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/xfl-zuo.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/xfl-you.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/xfl-xiangzuo.png', frame: 24 },
      { url: '/hotspots/system/changjingqiehuan/xfl-xiangyou.png', frame: 24 },
    ],
  },
  {
    name: '超链接',
    featType: FeatureType.link,
    list: [
      { url: '/hotspots/system/chaolianjie/lianjie.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/fangdajing.png', frame: 24 },
      { url: '/hotspots/system/chaolianjie/gantan.png', frame: 24 },
      { url: '/hotspots/system/chaolianjie/wenhao.png', frame: 24 },
      { url: '/hotspots/system/chaolianjie/biaoqian.png', frame: 24 },
      { url: '/hotspots/system/chaolianjie/chaba.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/dianduidian.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/guochengdian.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/juji.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/qidianzhongdian.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/xunhuan.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/yunduan.png', frame: 1 },
      { url: '/hotspots/system/chaolianjie/zhankai.png', frame: 1 },
    ],
  },
  {
    name: '电话',
    featType: FeatureType.mobile,
    list: [
      { url: '/hotspots/system/dianhua/dianhua1.png', frame: 1 },
      { url: '/hotspots/system/dianhua/dianhua2.png', frame: 24 },
      { url: '/hotspots/system/dianhua/dianhuabochu.png', frame: 1 },
      { url: '/hotspots/system/dianhua/duorenduihua.png', frame: 1 },
      { url: '/hotspots/system/dianhua/shipingtonghua.png', frame: 1 },
      { url: '/hotspots/system/dianhua/xiaolian.png', frame: 1 },
      { url: '/hotspots/system/dianhua/xinxichaxun.png', frame: 1 },
      { url: '/hotspots/system/dianhua/yiyuedu.png', frame: 1 },
    ],
  },
  {
    name: '导航',
    featType: FeatureType.map,
    list: [
      { url: '/hotspots/system/daohang/biaoji1.png', frame: 1 },
      { url: '/hotspots/system/daohang/diqiu.png', frame: 24 },
      { url: '/hotspots/system/daohang/biaoji2.png', frame: 24 },
      { url: '/hotspots/system/daohang/qizhi.png', frame: 24 },
      { url: '/hotspots/system/daohang/fanchuan.png', frame: 1 },
      { url: '/hotspots/system/daohang/feiji.png', frame: 1 },
      { url: '/hotspots/system/daohang/huoche.png', frame: 1 },
      { url: '/hotspots/system/daohang/lunchuan.png', frame: 1 },
      { url: '/hotspots/system/daohang/lvxingtuiche.png', frame: 1 },
      { url: '/hotspots/system/daohang/lvxingxiang.png', frame: 1 },
      { url: '/hotspots/system/daohang/menpiao.png', frame: 1 },
      { url: '/hotspots/system/daohang/reqiqiu.png', frame: 1 },
    ],
  },
  {
    name: '图文',
    featType: FeatureType.media,
    list: [
      { url: '/hotspots/system/tupian/tupian1.png', frame: 1 },
      { url: '/hotspots/system/tupian/tupian2.png', frame: 24 },
      { url: '/hotspots/system/tupian/xiangji.png', frame: 24 },
      { url: '/hotspots/system/tupian/jizhangtupian.png', frame: 1 },
      { url: '/hotspots/system/tupian/tupianjia.png', frame: 1 },
      { url: '/hotspots/system/tupian/yingmu.png', frame: 1 },
      { url: '/hotspots/system/tupian/yingmuzhankai.png', frame: 1 },
    ],
  },
  {
    name: '文本',
    featType: FeatureType.text,
    list: [
      { url: '/hotspots/system/wenzi/wenzi1.png', frame: 1 },
      { url: '/hotspots/system/wenzi/wenzi2.png', frame: 24 },
      { url: '/hotspots/system/wenzi/biaoge.png', frame: 1 },
      { url: '/hotspots/system/wenzi/cn.png', frame: 1 },
      { url: '/hotspots/system/wenzi/dabiaoqian.png', frame: 1 },
      { url: '/hotspots/system/wenzi/doc.png', frame: 1 },
      { url: '/hotspots/system/wenzi/en.png', frame: 1 },
      { url: '/hotspots/system/wenzi/pdf.png', frame: 1 },
      { url: '/hotspots/system/wenzi/ppt.png', frame: 1 },
      { url: '/hotspots/system/wenzi/wenben.png', frame: 1 },
      { url: '/hotspots/system/wenzi/xiewendang.png', frame: 1 },
    ],
  },
  {
    name: '文章',
    featType: FeatureType.article,
    list: [
      { url: '/hotspots/system/wenzhang/wenzhang1.png', frame: 1 },
      { url: '/hotspots/system/wenzhang/wenzhang2.png', frame: 24 },
      { url: '/hotspots/system/wenzhang/baozhi.png', frame: 1 },
      { url: '/hotspots/system/wenzhang/bi.png', frame: 1 },
      { url: '/hotspots/system/wenzhang/bijiben.png', frame: 1 },
      { url: '/hotspots/system/wenzhang/wendang.png', frame: 1 },
      { url: '/hotspots/system/wenzhang/wenzhang3.png', frame: 1 },
      { url: '/hotspots/system/wenzhang/wenzhang4.png', frame: 1 },
      { url: '/hotspots/system/wenzhang/wenzhang5.png', frame: 1 },
    ],
  },
  {
    name: '音频',
    featType: FeatureType.audio,
    list: [
      { url: '/hotspots/system/yinyue/yinping.png', frame: 1 },
      { url: '/hotspots/system/yinyue/yinbo.png', frame: 24 },
      { url: '/hotspots/system/yinyue/yinyue.png', frame: 24 },
      { url: '/hotspots/system/yinyue/CD.png', frame: 1 },
      { url: '/hotspots/system/yinyue/danyinfu.png', frame: 1 },
      { url: '/hotspots/system/yinyue/erji.png', frame: 1 },
      { url: '/hotspots/system/yinyue/erji1.png', frame: 1 },
      { url: '/hotspots/system/yinyue/maikefeng.png', frame: 1 },
      { url: '/hotspots/system/yinyue/tianjiayinyue.png', frame: 1 },
      { url: '/hotspots/system/yinyue/yingui.png', frame: 1 },
      { url: '/hotspots/system/yinyue/yinyueku.png', frame: 1 },
    ],
  },
  {
    name: '视频',
    featType: FeatureType.video,
    list: [
      { url: '/hotspots/system/shiping/shiping1.png', frame: 1 },
      { url: '/hotspots/system/shiping/shiping2.png', frame: 24 },
      { url: '/hotspots/system/shiping/shiping3.png', frame: 1 },
      { url: '/hotspots/system/shiping/shiping4.png', frame: 1 },
      { url: '/hotspots/system/shiping/shiping5.png', frame: 1 },
      { url: '/hotspots/system/shiping/shiping6.png', frame: 1 },
      { url: '/hotspots/system/shiping/shiping7.png', frame: 1 },
      { url: '/hotspots/system/shiping/xingbang.png', frame: 1 },
    ],
  },
  {
    name: '环物',
    featType: FeatureType.seqFrame,
    list: [
      { url: '/hotspots/system/zhuzheng/huanwu.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/3D.png', frame: 24 },
      { url: '/hotspots/system/zhuzheng/jufeng.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/lianjie.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/yuandianxian.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/zhengfangti.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/zhengfangti1.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/zhengfangti2.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/zhengfangti3.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/zhengfangti4.png', frame: 1 },
      { url: '/hotspots/system/zhuzheng/zhengfangxian.png', frame: 1 },
    ],
  },
  {
    name: '事件',
    featType: FeatureType.event,
    list: [{ url: '/hotspots/system/shijian/shijian.png', frame: 1 }],
  },
  {
    name: '无功能',
    featType: FeatureType.noFunc,
    list: [
      { url: '/hotspots/system/wugongnen/kongbai.png', frame: 1 },
      { url: '/hotspots/system/wugongnen/dian.png', frame: 24 },
    ],
  },
  {
    name: '3D',
    list: [
      { url: '/hotspots/system/3d/anquan.png', frame: 1 },
      { url: '/hotspots/system/3d/anquan1.png', frame: 1 },
      { url: '/hotspots/system/3d/baoxiangui.png', frame: 1 },
      { url: '/hotspots/system/3d/baoxiangui1.png', frame: 1 },
      { url: '/hotspots/system/3d/biaoda.png', frame: 1 },
      { url: '/hotspots/system/3d/biaoda1.png', frame: 1 },
      { url: '/hotspots/system/3d/biaoji.png', frame: 1 },
      { url: '/hotspots/system/3d/biaoji1.png', frame: 1 },
      { url: '/hotspots/system/3d/biaojixing.png', frame: 1 },
      { url: '/hotspots/system/3d/biaojixing1.png', frame: 1 },
      { url: '/hotspots/system/3d/biaoxingwenjianjia.png', frame: 1 },
      { url: '/hotspots/system/3d/biaoxingwenjianjia1.png', frame: 1 },
      { url: '/hotspots/system/3d/bishua.png', frame: 1 },
      { url: '/hotspots/system/3d/bishua1.png', frame: 1 },
      { url: '/hotspots/system/3d/chabei.png', frame: 1 },
      { url: '/hotspots/system/3d/chabei1.png', frame: 1 },
      { url: '/hotspots/system/3d/chabei2.png', frame: 1 },
      { url: '/hotspots/system/3d/dadianhua.png', frame: 1 },
      { url: '/hotspots/system/3d/dadianhua1.png', frame: 1 },
      { url: '/hotspots/system/3d/daizi.png', frame: 1 },
      { url: '/hotspots/system/3d/daizi1.png', frame: 1 },
      { url: '/hotspots/system/3d/danxiaoxi.png', frame: 1 },
      { url: '/hotspots/system/3d/danxiaoxi1.png', frame: 1 },
      { url: '/hotspots/system/3d/dinshuzheng.png', frame: 1 },
      { url: '/hotspots/system/3d/erji.png', frame: 1 },
      { url: '/hotspots/system/3d/erji1.png', frame: 1 },
      { url: '/hotspots/system/3d/gongju.png', frame: 1 },
      { url: '/hotspots/system/3d/gongwenbao.png', frame: 1 },
      { url: '/hotspots/system/3d/gongwenbao1.png', frame: 1 },
      { url: '/hotspots/system/3d/gouwudai.png', frame: 1 },
      { url: '/hotspots/system/3d/gouwudai1.png', frame: 1 },
      { url: '/hotspots/system/3d/guntong.png', frame: 1 },
      { url: '/hotspots/system/3d/guntong1.png', frame: 1 },
      { url: '/hotspots/system/3d/huangguan.png', frame: 1 },
      { url: '/hotspots/system/3d/huangguan1.png', frame: 1 },
      { url: '/hotspots/system/3d/jiandao.png', frame: 1 },
      { url: '/hotspots/system/3d/jiandao1.png', frame: 1 },
      { url: '/hotspots/system/3d/jiangbei.png', frame: 1 },
      { url: '/hotspots/system/3d/jiangbei1.png', frame: 1 },
      { url: '/hotspots/system/3d/jiangzhang.png', frame: 1 },
      { url: '/hotspots/system/3d/jiangzhang1.png', frame: 1 },
      { url: '/hotspots/system/3d/jiedianhua.png', frame: 1 },
      { url: '/hotspots/system/3d/jiedianhua1.png', frame: 1 },
      { url: '/hotspots/system/3d/jiubei.png', frame: 1 },
      { url: '/hotspots/system/3d/jiubei1.png', frame: 1 },
      { url: '/hotspots/system/3d/laba.png', frame: 1 },
      { url: '/hotspots/system/3d/laba1.png', frame: 1 },
      { url: '/hotspots/system/3d/lajitong.png', frame: 1 },
      { url: '/hotspots/system/3d/lajitong1.png', frame: 1 },
      { url: '/hotspots/system/3d/liwu.png', frame: 1 },
      { url: '/hotspots/system/3d/maikefeng.png', frame: 1 },
      { url: '/hotspots/system/3d/moshumao.png', frame: 1 },
      { url: '/hotspots/system/3d/moshumao1.png', frame: 1 },
      { url: '/hotspots/system/3d/qianbao.png', frame: 1 },
      { url: '/hotspots/system/3d/qianbao1.png', frame: 1 },
      { url: '/hotspots/system/3d/qizhi.png', frame: 1 },
      { url: '/hotspots/system/3d/qizhi1.png', frame: 1 },
      { url: '/hotspots/system/3d/qunxiaoxi.png', frame: 1 },
      { url: '/hotspots/system/3d/qunxiaoxi1.png', frame: 1 },
      { url: '/hotspots/system/3d/rili.png', frame: 1 },
      { url: '/hotspots/system/3d/rili1.png', frame: 1 },
      { url: '/hotspots/system/3d/sepan.png', frame: 1 },
      { url: '/hotspots/system/3d/sepan1.png', frame: 1 },
      { url: '/hotspots/system/3d/sepan2.png', frame: 1 },
      { url: '/hotspots/system/3d/sepan3.png', frame: 1 },
      { url: '/hotspots/system/3d/shezhi.png', frame: 1 },
      { url: '/hotspots/system/3d/shiyanbei.png', frame: 1 },
      { url: '/hotspots/system/3d/shiyanbei1.png', frame: 1 },
      { url: '/hotspots/system/3d/shuazi.png', frame: 1 },
      { url: '/hotspots/system/3d/shuazi1.png', frame: 1 },
      { url: '/hotspots/system/3d/shuben.png', frame: 1 },
      { url: '/hotspots/system/3d/shuben1.png', frame: 1 },
      { url: '/hotspots/system/3d/suo.png', frame: 1 },
      { url: '/hotspots/system/3d/taiyang.png', frame: 1 },
      { url: '/hotspots/system/3d/taiyang1.png', frame: 1 },
      { url: '/hotspots/system/3d/tupian.png', frame: 1 },
      { url: '/hotspots/system/3d/tupian1.png', frame: 1 },
      { url: '/hotspots/system/3d/weizhi.png', frame: 1 },
      { url: '/hotspots/system/3d/weizhi1.png', frame: 1 },
      { url: '/hotspots/system/3d/wenjian.png', frame: 1 },
      { url: '/hotspots/system/3d/wenjian1.png', frame: 1 },
      { url: '/hotspots/system/3d/wifi.png', frame: 1 },
      { url: '/hotspots/system/3d/xiangji.png', frame: 1 },
      { url: '/hotspots/system/3d/xiangji1.png', frame: 1 },
      { url: '/hotspots/system/3d/xiaoxi.png', frame: 1 },
      { url: '/hotspots/system/3d/xiaoxi1.png', frame: 1 },
      { url: '/hotspots/system/3d/xiguan.png', frame: 1 },
      { url: '/hotspots/system/3d/xiguan1.png', frame: 1 },
      { url: '/hotspots/system/3d/xing.png', frame: 1 },
      { url: '/hotspots/system/3d/xingjianwenjian.png', frame: 1 },
      { url: '/hotspots/system/3d/xingjianwenjian1.png', frame: 1 },
      { url: '/hotspots/system/3d/xinxi.png', frame: 1 },
      { url: '/hotspots/system/3d/xinxi1.png', frame: 1 },
      { url: '/hotspots/system/3d/yaoshi.png', frame: 1 },
      { url: '/hotspots/system/3d/yaoshi1.png', frame: 1 },
      { url: '/hotspots/system/3d/yingbi.png', frame: 1 },
      { url: '/hotspots/system/3d/yingbi1.png', frame: 1 },
      { url: '/hotspots/system/3d/yinyue.png', frame: 1 },
      { url: '/hotspots/system/3d/yinyue1.png', frame: 1 },
      { url: '/hotspots/system/3d/youqi.png', frame: 1 },
      { url: '/hotspots/system/3d/youqi1.png', frame: 1 },
      { url: '/hotspots/system/3d/yusan.png', frame: 1 },
      { url: '/hotspots/system/3d/yusan1.png', frame: 1 },
      { url: '/hotspots/system/3d/yuyinganxin.png', frame: 1 },
      { url: '/hotspots/system/3d/yuyinganxin1.png', frame: 1 },
      { url: '/hotspots/system/3d/zan.png', frame: 1 },
      { url: '/hotspots/system/3d/zan1.png', frame: 1 },
      { url: '/hotspots/system/3d/zhibei.png', frame: 1 },
      { url: '/hotspots/system/3d/zhibei1.png', frame: 1 },
    ],
  },
  {
    name: '餐饮',
    list: [
      { url: '/hotspots/system/canying/bingqiling.png', frame: 1 },
      { url: '/hotspots/system/canying/bingqiling(1).png', frame: 1 },
      { url: '/hotspots/system/canying/cha.png', frame: 1 },
      { url: '/hotspots/system/canying/dangao.png', frame: 1 },
      { url: '/hotspots/system/canying/daocha.png', frame: 1 },
      { url: '/hotspots/system/canying/gaojiaobei.png', frame: 1 },
      { url: '/hotspots/system/canying/goutou.png', frame: 1 },
      { url: '/hotspots/system/canying/guo.png', frame: 1 },
      { url: '/hotspots/system/canying/hanbao.png', frame: 1 },
      { url: '/hotspots/system/canying/huoguo.png', frame: 1 },
      { url: '/hotspots/system/canying/jidan.png', frame: 1 },
      { url: '/hotspots/system/canying/jiubei.png', frame: 1 },
      { url: '/hotspots/system/canying/mianbao.png', frame: 1 },
      { url: '/hotspots/system/canying/miantiao.png', frame: 1 },
      { url: '/hotspots/system/canying/pijiu.png', frame: 1 },
      { url: '/hotspots/system/canying/pingguo.png', frame: 1 },
    ],
  },
  {
    name: '服饰',
    list: [
      { url: '/hotspots/system/fushi/bijini.png', frame: 1 },
      { url: '/hotspots/system/fushi/gaogengxie.png', frame: 1 },
      { url: '/hotspots/system/fushi/hudiejie.png', frame: 1 },
      { url: '/hotspots/system/fushi/liantiyi.png', frame: 1 },
      { url: '/hotspots/system/fushi/lingdai.png', frame: 1 },
      { url: '/hotspots/system/fushi/maozi.png', frame: 1 },
      { url: '/hotspots/system/fushi/qiuyi.png', frame: 1 },
      { url: '/hotspots/system/fushi/shubao.png', frame: 1 },
      { url: '/hotspots/system/fushi/wazi.png', frame: 1 },
      { url: '/hotspots/system/fushi/yanjing.png', frame: 1 },
      { url: '/hotspots/system/fushi/yifu.png', frame: 1 },
      { url: '/hotspots/system/fushi/yijia.png', frame: 1 },
    ],
  },
  {
    name: '工业',
    list: [
      { url: '/hotspots/system/fushi/banshou.png', frame: 1 },
      { url: '/hotspots/system/fushi/dianchi.png', frame: 1 },
      { url: '/hotspots/system/fushi/dianzuan.png', frame: 1 },
      { url: '/hotspots/system/fushi/fengche.png', frame: 1 },
      { url: '/hotspots/system/fushi/huaduo.png', frame: 1 },
      { url: '/hotspots/system/fushi/jiqiren.png', frame: 1 },
      { url: '/hotspots/system/fushi/miehuoqi.png', frame: 1 },
      { url: '/hotspots/system/fushi/qiche.png', frame: 1 },
      { url: '/hotspots/system/fushi/qizi.png', frame: 1 },
      { url: '/hotspots/system/fushi/shu.png', frame: 1 },
      { url: '/hotspots/system/fushi/shuye.png', frame: 1 },
      { url: '/hotspots/system/fushi/tizi.png', frame: 1 },
      { url: '/hotspots/system/fushi/xiyifen.png', frame: 1 },
      { url: '/hotspots/system/fushi/zhongzi.png', frame: 1 },
    ],
  },
  {
    name: '家居',
    list: [
      { url: '/hotspots/system/jiaju/chuifenji.png', frame: 1 },
      { url: '/hotspots/system/jiaju/danrenchuang.png', frame: 1 },
      { url: '/hotspots/system/jiaju/guizi.png', frame: 1 },
      { url: '/hotspots/system/jiaju/mensuo.png', frame: 1 },
      { url: '/hotspots/system/jiaju/shuangrenchuang.png', frame: 1 },
      { url: '/hotspots/system/jiaju/yaoyaoma.png', frame: 1 },
      { url: '/hotspots/system/jiaju/yidonggui.png', frame: 1 },
      { url: '/hotspots/system/jiaju/yierche.png', frame: 1 },
      { url: '/hotspots/system/jiaju/yugang.png', frame: 1 },
      { url: '/hotspots/system/jiaju/yundou.png', frame: 1 },
      { url: '/hotspots/system/jiaju/zheyangsan.png', frame: 1 },
    ],
  },
  {
    name: '人物',
    list: [
      { url: '/hotspots/system/renwu/daxiang.png', frame: 1 },
      { url: '/hotspots/system/renwu/hudie.png', frame: 1 },
      { url: '/hotspots/system/renwu/hudun.png', frame: 1 },
      { url: '/hotspots/system/renwu/lianxibu.png', frame: 1 },
      { url: '/hotspots/system/renwu/mao.png', frame: 1 },
      { url: '/hotspots/system/renwu/nanren.png', frame: 1 },
      { url: '/hotspots/system/renwu/nansheng.png', frame: 1 },
      { url: '/hotspots/system/renwu/nvren.png', frame: 1 },
      { url: '/hotspots/system/renwu/nvsheng.png', frame: 1 },
      { url: '/hotspots/system/renwu/renwuxunhuan.png', frame: 1 },
      { url: '/hotspots/system/renwu/sangeren.png', frame: 1 },
      { url: '/hotspots/system/renwu/WC.png', frame: 1 },
      { url: '/hotspots/system/renwu/weixiao.png', frame: 1 },
      { url: '/hotspots/system/renwu/xiong.png', frame: 1 },
      { url: '/hotspots/system/renwu/yonghu.png', frame: 1 },
      { url: '/hotspots/system/renwu/yonghu1.png', frame: 1 },
      { url: '/hotspots/system/renwu/yu.png', frame: 1 },
      { url: '/hotspots/system/renwu/zhu.png', frame: 1 },
    ],
  },
  {
    name: '商业',
    list: [
      { url: '/hotspots/system/renwu/dianti.png', frame: 1 },
      { url: '/hotspots/system/renwu/gouwu.png', frame: 1 },
      { url: '/hotspots/system/renwu/gouwuche.png', frame: 1 },
      { url: '/hotspots/system/renwu/gouwudai.png', frame: 1 },
      { url: '/hotspots/system/renwu/jiaotang.png', frame: 1 },
      { url: '/hotspots/system/renwu/loufang.png', frame: 1 },
      { url: '/hotspots/system/renwu/loufang1.png', frame: 1 },
      { url: '/hotspots/system/renwu/loufang2.png', frame: 1 },
      { url: '/hotspots/system/renwu/meiyuan.png', frame: 1 },
      { url: '/hotspots/system/renwu/motianlun.png', frame: 1 },
      { url: '/hotspots/system/renwu/qianbao.png', frame: 1 },
      { url: '/hotspots/system/renwu/qianwu.png', frame: 1 },
      { url: '/hotspots/system/renwu/qiao.png', frame: 1 },
      { url: '/hotspots/system/renwu/shangdian.png', frame: 1 },
      { url: '/hotspots/system/renwu/shuben.png', frame: 1 },
      { url: '/hotspots/system/renwu/shuben1.png', frame: 1 },
      { url: '/hotspots/system/renwu/tieta.png', frame: 1 },
      { url: '/hotspots/system/renwu/xinyongka.png', frame: 1 },
      { url: '/hotspots/system/renwu/yingbi.png', frame: 1 },
      { url: '/hotspots/system/shangye/xiaochengxu1.png', frame: 1 },
      { url: '/hotspots/system/shangye/ie1.png', frame: 1 },
      { url: '/hotspots/system/shangye/meituan1.png', frame: 1 },
      { url: '/hotspots/system/shangye/xiaochengxu.png', frame: 1 },
      { url: '/hotspots/system/shangye/meituan.png', frame: 1 },
      { url: '/hotspots/system/shangye/xiecheng.png', frame: 1 },
      { url: '/hotspots/system/shangye/ie.png', frame: 1 },
      { url: '/hotspots/system/shangye/taobao.png', frame: 1 },
      { url: '/hotspots/system/shangye/weixin.png', frame: 1 },
      { url: '/hotspots/system/shangye/weixin1.png', frame: 1 },
      { url: '/hotspots/system/shangye/weibo.png', frame: 1 },
      { url: '/hotspots/system/shangye/jindong1.png', frame: 1 },
      { url: '/hotspots/system/shangye/jindong.png', frame: 1 },
      { url: '/hotspots/system/shangye/xiecheng1.png', frame: 1 },
      { url: '/hotspots/system/shangye/taobao1.png', frame: 1 },
    ],
  },
  {
    name: '医疗',
    list: [
      { url: '/hotspots/system/yiliao/bingdu.png', frame: 1 },
      { url: '/hotspots/system/yiliao/bizi.png', frame: 1 },
      { url: '/hotspots/system/yiliao/cheng.png', frame: 1 },
      { url: '/hotspots/system/yiliao/jiuhuche.png', frame: 1 },
      { url: '/hotspots/system/yiliao/kouzhao.png', frame: 1 },
      { url: '/hotspots/system/yiliao/xintiao.png', frame: 1 },
      { url: '/hotspots/system/yiliao/xinzang.png', frame: 1 },
      { url: '/hotspots/system/yiliao/yachi.png', frame: 1 },
      { url: '/hotspots/system/yiliao/yanjing.png', frame: 1 },
      { url: '/hotspots/system/yiliao/yaoping.png', frame: 1 },
      { url: '/hotspots/system/yiliao/yaowan.png', frame: 1 },
      { url: '/hotspots/system/yiliao/yaowan(1).png', frame: 1 },
      { url: '/hotspots/system/yiliao/yaoxiang.png', frame: 1 },
      { url: '/hotspots/system/yiliao/yezi.png', frame: 1 },
      { url: '/hotspots/system/yiliao/yiliao.png', frame: 1 },
      { url: '/hotspots/system/yiliao/zheng.png', frame: 1 },
    ],
  },
  {
    name: '运动',
    list: [
      { url: '/hotspots/system/yinyue/bangqiu.png', frame: 1 },
      { url: '/hotspots/system/yinyue/fanchuan.png', frame: 1 },
      { url: '/hotspots/system/yinyue/gongjian.png', frame: 1 },
      { url: '/hotspots/system/yinyue/jiangzhuang.png', frame: 1 },
      { url: '/hotspots/system/yinyue/jiangzhuang1.png', frame: 1 },
      { url: '/hotspots/system/yinyue/jifenpai.png', frame: 1 },
      { url: '/hotspots/system/yinyue/koushao.png', frame: 1 },
      { url: '/hotspots/system/yinyue/lanqiuchang.png', frame: 1 },
      { url: '/hotspots/system/yinyue/miaozhun.png', frame: 1 },
      { url: '/hotspots/system/yinyue/paobuji.png', frame: 1 },
      { url: '/hotspots/system/yinyue/qiche.png', frame: 1 },
      { url: '/hotspots/system/yinyue/quanji.png', frame: 1 },
      { url: '/hotspots/system/yinyue/yaling.png', frame: 1 },
      { url: '/hotspots/system/yinyue/yongchi.png', frame: 1 },
      { url: '/hotspots/system/yinyue/yumaoqiu.png', frame: 1 },
    ],
  },
  {
    name: '1.0版',
    list: [
      { url: '/hotspots/system/v1.0/01_new_spotd1_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/02_new_spotd2_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/03_new_spotd3_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/04_new_spotd4_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/05_new_spotd5_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/06_spotd3_gif.png', frame: 10 },
      { url: '/hotspots/system/v1.0/07_new_spotd12_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/08_spotd5_gif.png', frame: 10 },
      { url: '/hotspots/system/v1.0/09_new_spotd11_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/10_spotd1_gif.png', frame: 10 },
      { url: '/hotspots/system/v1.0/11_spotd2_gif.png', frame: 10 },
      { url: '/hotspots/system/v1.0/12_new_spotd6_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/13_new_spotd7_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/14_spotd4_gif.png', frame: 10 },
      { url: '/hotspots/system/v1.0/15_new_spotd8_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/16_new_spotd9_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/17_new_spotd10_gif.png', frame: 25 },
      { url: '/hotspots/system/v1.0/18_new_spotd1.png', frame: 1 },
      { url: '/hotspots/system/v1.0/19_new_spotd2.png', frame: 1 },
      { url: '/hotspots/system/v1.0/20_new_spotd3.png', frame: 1 },
      { url: '/hotspots/system/v1.0/21_new_spotd4.png', frame: 1 },
      { url: '/hotspots/system/v1.0/22_new_spotd5.png', frame: 1 },
      { url: '/hotspots/system/v1.0/23_spotd3.png', frame: 1 },
      { url: '/hotspots/system/v1.0/24_spot7.png', frame: 1 },
      { url: '/hotspots/system/v1.0/25_spot4.png', frame: 1 },
      { url: '/hotspots/system/v1.0/26_spot1.png', frame: 1 },
      { url: '/hotspots/system/v1.0/27_spot17.png', frame: 1 },
      { url: '/hotspots/system/v1.0/28_spot16.png', frame: 1 },
      { url: '/hotspots/system/v1.0/29_new_spotd12.png', frame: 1 },
      { url: '/hotspots/system/v1.0/30_spotd5.png', frame: 1 },
      { url: '/hotspots/system/v1.0/31_new_spotd11.png', frame: 1 },
      { url: '/hotspots/system/v1.0/32_spotd1.png', frame: 1 },
      { url: '/hotspots/system/v1.0/33_spotd21.png', frame: 1 },
      { url: '/hotspots/system/v1.0/34_spotd2.png', frame: 1 },
      { url: '/hotspots/system/v1.0/35_new_spotd6.png', frame: 1 },
      { url: '/hotspots/system/v1.0/36_spotd4.png', frame: 1 },
      { url: '/hotspots/system/v1.0/37_new_spotd8.png', frame: 1 },
      { url: '/hotspots/system/v1.0/38_new_spotd9.png', frame: 1 },
      { url: '/hotspots/system/v1.0/39_spot5.png', frame: 1 },
      { url: '/hotspots/system/v1.0/40_new_spotd10.png', frame: 1 },
      { url: '/hotspots/system/v1.0/41_spot15.png', frame: 1 },
      { url: '/hotspots/system/v1.0/42_spot14.png', frame: 1 },
      { url: '/hotspots/system/v1.0/43_spot13.png', frame: 1 },
      { url: '/hotspots/system/v1.0/44_spot3.png', frame: 1 },
      { url: '/hotspots/system/v1.0/45_spot2.png', frame: 1 },
      { url: '/hotspots/system/v1.0/46_spot8.png', frame: 1 },
      { url: '/hotspots/system/v1.0/47_spot6.png', frame: 1 },
      { url: '/hotspots/system/v1.0/48_spot12.png', frame: 1 },
      { url: '/hotspots/system/v1.0/49_spot10.png', frame: 1 },
      { url: '/hotspots/system/v1.0/50_spot18.png', frame: 1 },
      { url: '/hotspots/system/v1.0/51_spot19.png', frame: 1 },
      { url: '/hotspots/system/v1.0/52_spot11.png', frame: 1 },
      { url: '/hotspots/system/v1.0/53_static_link.png', frame: 1 },
      { url: '/hotspots/system/v1.0/54_static_txt.png', frame: 1 },
      { url: '/hotspots/system/v1.0/55_static_music.png', frame: 1 },
      { url: '/hotspots/system/v1.0/56_static_video.png', frame: 1 },
      { url: '/hotspots/system/v1.0/57_static_gallery.png', frame: 1 },
      { url: '/hotspots/system/v1.0/58_spot20.png', frame: 1 },
    ],
  },
];

export const sysIconList: Group[] = [
  {
    name: '全部',
    list: iconList.map((x) => x.list).reduce((acc, cur) => acc.concat(cur)),
  },
  ...iconList,
];
